import {
  GET_ERRORS,
  CLEAR_ERRORS,
  POSTING_LOADING,
  CLEAR_LOADING,
  GET_CAROUSELS, 
  GET_MEMBER_ACTIONS,
  GET_MEMBER_ACTION_IS_READ,
  UPDATE_MEMBER_ACTION_IS_READ,
  GET_ORDERS,
} from './types';

import axios from 'axios';

export const postLoading = () => {
  return {
    type: POSTING_LOADING,
  };
};
export const clearLoading = () => {
  return {
    type: CLEAR_LOADING,
  };
};

export const getCarousels = () => (dispatch) => {
  axios
    .get('/api/member/get_carousels')
    .then((res) => {
      dispatch({
        type: GET_CAROUSELS,
        payload: res.data.msg,
      });
    })
    .catch((err) => {
      dispatch({
        type: GET_ERRORS,
        payload: err.response.data,
      });
    });
};

export const getMemberActions = () => (dispatch) => {
  axios
    .get('/api/member/get_member_actions')
    .then((res) => {
      dispatch({
        type: GET_MEMBER_ACTIONS,
        payload: res.data.msg,
      });
    })
    .catch((err) => {
      dispatch({
        type: GET_ERRORS,
        payload: err.response.data,
      });
    });
};

export const getMemberActionIsRead = () => (dispatch) => {
  axios
    .get('/api/member/get_member_action_is_read')
    .then((res) => {
      dispatch({
        type: GET_MEMBER_ACTION_IS_READ,
        payload: res.data.msg,
      });
    })
    .catch((err) => {
      dispatch({
        type: GET_ERRORS,
        payload: err.response.data,
      });
    });
};

export const updateMemberActionIsRead = () => (dispatch) => {
  axios
    .get('/api/member/update_member_action_is_read')
    .then((res) => {
      dispatch({
        type: UPDATE_MEMBER_ACTION_IS_READ,
        payload: res.data.msg,
      });
    })
    .catch((err) => {
      dispatch({
        type: GET_ERRORS,
        payload: err.response.data,
      });
    });
};

export const getOrders = (data) => (dispatch) => {
  axios
    .post('/api/member/get_orders', data)
    .then((res) => {
      dispatch({
        type: GET_ORDERS,
        payload: res.data.msg,
      });
    })
    .catch((err) => {
      dispatch({
        type: GET_ERRORS,
        payload: err.response.data,
      });
    });
};

export const clearErrors = () => {
  return {
    type: CLEAR_ERRORS,
  };
};
